import * as React from 'react';
import { usePaginationContext } from '../contexts/PaginationContext';
export function getIsActive(title, orderBy) {
  return title === orderBy;
}
export function getDirection(title, orderBy, order) {
  return title === orderBy ? order : 'asc';
}
export const handleSwitchOrder = setOrder => {
  setOrder(prevState => {
    const isAsc = prevState === 'asc';
    const newValue = isAsc ? 'desc' : 'asc';
    return newValue;
  });
  return null;
};
const handleRequestOrder = ({
  setOrder,
  setOrderBy,
  title,
  setPage
}) => {
  handleSwitchOrder(setOrder);
  setOrderBy(title);
  setPage(0);
};
// Hook
function useOrder({
  initialOrder = 'asc',
  initialOrderBy = ''
}) {
  const [orderBy, setOrderBy] = React.useState(initialOrderBy);
  const [order, setOrder] = React.useState(initialOrder);
  const {
    setPage
  } = usePaginationContext();
  const resetOrder = React.useCallback(() => {
    setOrderBy('');
    setPage(0);
  }, [setPage]);
  const getTableSortProps = React.useCallback(title => {
    return {
      direction: getDirection(title, orderBy, order),
      active: getIsActive(title, orderBy),
      onClick: () => handleRequestOrder({
        setOrder,
        setOrderBy,
        title,
        setPage
      })
    };
  }, [orderBy, order, setPage]);
  const values = React.useMemo(() => ({
    order,
    orderBy,
    getTableSortProps,
    resetOrder
  }), [order, orderBy, getTableSortProps, resetOrder]);
  return values;
}
export default useOrder;